import { WINDOW_TARGET } from "../../consts";

export const isPublicTourPath = () => {
  const pathName = window.location.pathname.split('/')[1];
  return pathName.includes('public-tours');
};

export const openWindow = (url, target = WINDOW_TARGET.BLANK, features = '') => {
  if (!url) return null;

  return window.open(url, target, features);
};